// Engelsk oversættelse (ui): dansk tekst -> engelsk. Se ../index.js og I18N.md.
export default {
	"Koordinater kopieret": "Coordinates copied",
	"Kunne ikke kopiere koordinater": "Could not copy coordinates",
	"Kopieret": "Copied",
	"Kunne ikke kopiere": "Could not copy",
	"Kopiér koordinater": "Copy coordinates",
	"Rørmåling kopieret": "Pipe measurement copied",
	"Kunne ikke kopiere rørmåling": "Could not copy pipe measurement",
	"Kopiér rørmåling": "Copy pipe measurement",
	"Luk": "Close",
	"Start": "Start",
	"Slut": "End",
	"Forbindelsen til {0} blev brudt (kun {1} flyttet)": "The connection to {0} was broken (only {1} moved)",
	"Handlingen kunne ikke udføres.": "The action could not be performed.",
	"Objektet kunne ikke slettes. Det er bevaret.": "The object could not be deleted. It has been kept.",
	"{0} objekt blev ikke slettet{1}": "{0} object was not deleted{1}",
	"{0} objekter blev ikke slettet{1}": "{0} objects were not deleted{1}",
	"Beregnet punkt": "Calculated point",
	"Afstand": "Distance",
	"Angiv en fast afstand, eller lad feltet stå tomt for at vælge afstanden dynamisk med musen under registrering.": "Enter a fixed distance, or leave the field empty to choose the distance dynamically with the mouse during registration.",
	"Afstand [m]": "Distance [m]",
	"Valgfri - tom = dynamisk": "Optional - empty = dynamic",
	"Annuller": "Cancel",
	"Fortsæt": "Continue",
	"Standard PointView": "PointView standard",
	"Ny profil": "New profile",
	"Attributter": "Attributes",
	"Navn": "Name",
	"Objekt-ID": "Object ID",
	"Kategori": "Category",
	"Værktøj": "Tool",
	"Featuretype": "Feature type",
	"Geometritype": "Geometry type",
	"Beskrivelse": "Description",
	"Oprettet": "Created",
	"Ændret": "Modified",
	"Vertexnummer": "Vertex number",
	"Antal punkter": "Number of points",
	"Længde (m)": "Length (m)",
	"Omkreds (m)": "Perimeter (m)",
	"Startpunkt X": "Start point X",
	"Startpunkt Y": "Start point Y",
	"Startpunkt Z": "Start point Z",
	"Slutpunkt X": "End point X",
	"Slutpunkt Y": "End point Y",
	"Slutpunkt Z": "End point Z",
	"Centroide X": "Centroid X",
	"Centroide Y": "Centroid Y",
	"Centroide Z": "Centroid Z",
	"Rør": "Pipe",
	"Dimension (mm)": "Dimension (mm)",
	"Radius (m)": "Radius (m)",
	"Indvendig radius (m)": "Inner radius (m)",
	"Godstykkelse (m)": "Wall thickness (m)",
	"Centerkote (m)": "Center elevation (m)",
	"Topkote, udvendig (m)": "Top elevation, outer (m)",
	"Bundkote, udvendig (m)": "Bottom elevation, outer (m)",
	"Topkote, indvendig (m)": "Top elevation, inner (m)",
	"Bundkote, indvendig (m)": "Bottom elevation, inner (m)",
	"Analyseret længde (m)": "Analyzed length (m)",
	"Dækningsvinkel (grader)": "Coverage angle (degrees)",
	"Kvalitet": "Quality",
	"Reduceret nøjagtighed": "Reduced accuracy",
	"CSV": "CSV",
	"Tabel efter en CSV-profil (Standard PointView eller en gemt profil).": "Table according to a CSV profile (PointView standard or a saved profile).",
	"CSV-profil": "CSV profile",
	"Uncategorized": "Uncategorized",
	"DXF": "DXF",
	"AutoCAD DXF (R12) med højde (Z). Lag følger registreringernes kategori; navne skrives som tekst.": "AutoCAD DXF (R12) with elevation (Z). Layers follow the category of the registrations; names are written as text.",
	"Ukendt eller utilgængeligt eksportformat.": "Unknown or unavailable export format.",
	"Ingen registreringer at gemme.": "No registrations to save.",
	"GeoJSON": "GeoJSON",
	"Alle attributter og koordinater med højde (Z). Egnet til GIS og web.": "All attributes and coordinates with elevation (Z). Suitable for GIS and web.",
	"ESRI Shapefile": "ESRI Shapefile",
	"ZIP med separate lag for punkter, linjer og polygoner (med højde) og attributtabel.": "ZIP with separate layers for points, lines and polygons (with elevation) and an attribute table.",
	"Ingen eksporterbare geometrier i det valgte omfang.": "No exportable geometries in the selected scope.",
	"Indsæt punkt": "Insert point",
	"Ny mappe": "New folder",
	"Procenthældning: lodret": "Percent slope: vertical",
	"Promillehældning: {0}‰": "Per mille slope: {0}‰",
	"Procenthældning: {0}%": "Percent slope: {0}%",
	"Retningspunkterne ligger for tæt på hinanden til at angive en rørretning.": "The direction points are too close together to define a pipe direction.",
	"Retningsstykket er for langt ({0} m). Højst {1} m er tilladt - vælg det andet retningspunkt tættere på det første.": "The direction segment is too long ({0} m). At most {1} m is allowed - choose the second direction point closer to the first.",
	"Kunne ikke beregne en initial cirkel ud fra de fem seed-punkter - prøv at sprede dem mere.": "Could not calculate an initial circle from the five seed points - try spreading them out more.",
	"For få punktskypunkter fundet omkring det udpegede rør til en sikker beregning.": "Too few point cloud points found around the selected pipe for a reliable calculation.",
	"Kunne ikke tilpasse en cylinder til punktskydataene omkring røret.": "Could not fit a cylinder to the point cloud data around the pipe.",
	"For få punkter passer til en cylinderoverflade til en sikker dimensionsbestemmelse.": "Too few points fit a cylinder surface for a reliable dimension determination.",
	"Den robuste tilpasning konvergerede ikke til en gyldig cylinder.": "The robust fit did not converge to a valid cylinder.",
	"Den beregnede cylinder passer ikke til de fem udpegede seed-punkters lokale overflade - resultatet ser ud til at være låst til en anden overflade end den, du pegede på. Prøv igen med seed-punkter tættere på rørets synlige overflade.": "The calculated cylinder does not match the local surface of the five selected seed points - the result seems to be locked to a different surface than the one you pointed at. Try again with seed points closer to the visible surface of the pipe.",
	"Den beregnede cylinder er for stor i forhold til søgeområdet omkring røret - punktskyen omkring seed-punkterne ligner ikke et rør her.": "The calculated cylinder is too large relative to the search area around the pipe - the point cloud around the seed points does not look like a pipe here.",
	"Den beregnede rørradius er urealistisk - kontrollér at retnings- og seed-punkterne er placeret korrekt på røret.": "The calculated pipe radius is unrealistic - check that the direction and seed points are placed correctly on the pipe.",
	"For få punkter passer til den endelige cylinder til en sikker dimensionsbestemmelse.": "Too few points fit the final cylinder for a reliable dimension determination.",
	"De punkter, der understøtter cylinderen, er koncentreret i et for kort stykke af det analyserede område til en sikker rørmåling. Prøv med retningspunkter, der spænder over en større del af det synlige rør.": "The points that support the cylinder are concentrated in too short a stretch of the analyzed area for a reliable pipe measurement. Try direction points that span a larger part of the visible pipe.",
	"Rørets radius varierer for meget langs det analyserede stykke til at være et ægte, jævnt rør her - punktskyen ligner ikke en ensartet cylinder.": "The pipe radius varies too much along the analyzed stretch to be a genuine, smooth pipe here - the point cloud does not look like a uniform cylinder.",
	"Den synlige rørkrumning er ikke konsistent langs det analyserede stykke - den samlede dækning ser ud til at stamme fra forskellige overflader forskellige steder langs røret.": "The visible pipe curvature is not consistent along the analyzed stretch - the overall coverage seems to come from different surfaces at different places along the pipe.",
	"Den angivne godstykkelse er større end eller lig den beregnede udvendige radius.": "The specified wall thickness is greater than or equal to the calculated outer radius.",
	"Utilstrækkelig synlig røroverflade til sikker dimensionsbestemmelse.": "Insufficient visible pipe surface for a reliable dimension determination.",
	"Punktskydata omkring røret passer for dårligt til en cylinder til et sikkert resultat.": "The point cloud data around the pipe fits a cylinder too poorly for a reliable result.",
	"God": "Good",
	"Acceptabel": "Acceptable",
	"Usikker": "Uncertain",
	"Initialiserer…": "Initializing…",
	"Forfiner model…": "Refining model…",
	"Den beskårne overflade har {0} rand-løkker (forventede præcis 1) - lukning af beregningsvolumen afbrydes frem for at gætte. Interne huller skal lukkes, og overfladen skal være sammenhængende, før dette trin kaldes.": "The trimmed surface has {0} boundary loops (expected exactly 1) - closing the calculation volume is aborted rather than guessing. Internal holes must be closed and the surface must be connected before this step is called.",
	"Den beskårne overflades rand-løkke har færre end 3 punkter - kan ikke lukkes til en volumen.": "The boundary loop of the trimmed surface has fewer than 3 points - it cannot be closed into a volume.",
	"buildBoundaryCurtain: surfaceLoop og capLoop skal have samme længde (indeks-for-indeks korrespondance).": "buildBoundaryCurtain: surfaceLoop and capLoop must have the same length (index-for-index correspondence).",
	"Mesh-randen kunne ikke lukkes til en sammenhængende løkke - beregningen afbrydes frem for at gætte.": "The mesh boundary could not be closed into a connected loop - the calculation is aborted rather than guessing.",
	"selectExcavationSurface kræver polygonUV (det digitaliserede polygons rand) for at kunne afgøre hvilken geometri der hører til excavationen.": "selectExcavationSurface requires polygonUV (the edge of the digitized polygon) to be able to decide which geometry belongs to the excavation.",
	"Ingen af de rekonstruerede overflade-komponenter rører polygonets rand - beregningen afbrydes frem for at gætte.": "None of the reconstructed surface components touch the edge of the polygon - the calculation is aborted rather than guessing.",
	"Plan-klipningen kunne ikke lukkes til en sammenhængende rand-løkke - beregningen afbrydes frem for at gætte.": "The plane clipping could not be closed into a connected boundary loop - the calculation is aborted rather than guessing.",
	"3D-rekonstruktionen gav ingen overflade - for få eller for spredte punktsky-observationer inden for polygonet.": "The 3D reconstruction produced no surface - too few or too scattered point cloud observations inside the polygon.",
	"Ingen del af den rekonstruerede overflade ligger inden for polygonets rand.": "No part of the reconstructed surface lies inside the edge of the polygon.",
	"Den fysiske overflade kunne ikke valideres: {0}": "The physical surface could not be validated: {0}",
	"Geometrien kunne ikke gemmes. Den er sat tilbage.": "The geometry could not be saved. It has been restored.",
	"Højde: {0}": "Height: {0}",
	"Vælg et emne, eller søg efter et værktøj eller et begreb.": "Select a topic, or search for a tool or a term.",
	"Søg i hjælpen…": "Search the help…",
	"Søg i hjælpen": "Search the help",
	"Ingen emner matcher “{0}”.": "No topics match “{0}”.",
	"1 emne": "1 topic",
	"{0} emner": "{0} topics",
	"‹ Tilbage": "‹ Back",
	"‹ Alle emner": "‹ All topics",
	"Relaterede værktøjer": "Related tools",
	"Information: ": "Information:",
	"Position": "Position",
	"Geometri": "Geometry",
	"Redigering": "Editing",
	"Konstruktion": "Construction",
	"Struktur": "Structure",
	"Positionering": "Placement",
	"Udvid valg": "Expand selection",
	"Rapport": "Report",
	"Integration": "Integration",
	"Punkt": "Point",
	"Endepunkt": "Endpoint",
	"Linjepunkt": "Line point",
	"Flyt": "Move",
	"Flyt punkt": "Move point",
	"Flyt punkt i Z…": "Move point in Z…",
	"Flyt linje i Z…": "Move line in Z…",
	"Flyt segment i Z…": "Move segment in Z…",
	"Flyt del i Z…": "Move part in Z…",
	"Sæt kote…": "Set elevation…",
	"Snap til punktsky": "Snap to point cloud",
	"Snap til andet punkt…": "Snap to another point…",
	"Del linje her": "Split line here",
	"Fortsæt linje…": "Continue line…",
	"Forlæng til reference…": "Extend to reference…",
	"Forlæng endesegment…": "Extend end segment…",
	"Trim til reference…": "Trim to reference…",
	"Forbind til andet endepunkt…": "Connect to another endpoint…",
	"Slet objekt": "Delete object",
	"Slet punkt": "Delete point",
	"Trim mod linje…": "Trim against line…",
	"Rediger bue…": "Edit arc…",
	"Vend bue": "Flip arc",
	"Opløs bue": "Dissolve arc",
	"Fast vinkel…": "Fixed angle…",
	"Parallel med reference…": "Parallel to reference…",
	"Vinkelret på reference…": "Perpendicular to reference…",
	"Sæt punkt ved skæring…": "Set point at intersection…",
	"Vælg sammenhængende del…": "Select connected section…",
	"Vælg hele objektet": "Select entire object",
	"Segment": "Segment",
	"Ret ud i 2D": "Straighten in 2D",
	"Ret ud i 3D": "Straighten in 3D",
	"Bue fra pilhøjde…": "Arc from sagitta…",
	"Interpolér Z mellem punkter": "Interpolate Z between points",
	"Sæt fald/hældning…": "Set fall/slope…",
	"Forenkle": "Simplify",
	"Ortogonaliser": "Orthogonalize",
	"Fordel punkter lige": "Distribute points evenly",
	"Omtegn del…": "Redraw section…",
	"Sammenhængende del ({0} segmenter)": "Connected section ({0} segments)",
	"Linje": "Line",
	"Polygon": "Polygon",
	"Tværprofil": "Cross-section",
	"Måling": "Measurement",
	"Opløs {0}": "Dissolve {0}",
	"Snap alle punkter til punktsky": "Snap all points to point cloud",
	"Vend retning": "Reverse direction",
	"Saml med anden linje…": "Join with another line…",
	"Vis rapport": "Show report",
	"Objekt": "Object",
	"Find rør": "Find pipe",
	"Status": "Status",
	"Resultat": "Result",
	"Rørmåling": "Pipe measurement",
	"⚠ Reduceret nøjagtighed (løsere tolerance)": "⚠ Reduced accuracy (looser tolerance)",
	"Punktskydata passer dårligt til en cylinder": "The point cloud data fits a cylinder poorly",
	"Den normale beregning kunne ikke finde et sikkert resultat.\n\n": "The normal calculation could not find a reliable result.\n\n",
	"Du kan vælge at genberegne med en løsere tolerance. Det giver et resultat, men det vil være mindre nøjagtigt end normalt, og bør kontrolleres i felten.": "You can choose to recalculate with a looser tolerance. This gives a result, but it will be less accurate than normal and should be checked in the field.",
	"Genberegn (mindre nøjagtigt)": "Recalculate (less accurate)",
	"Den normale beregning kunne ikke finde et sikkert resultat.": "The normal calculation could not find a reliable result.",
	"Du kan vælge at genberegne med en løsere tolerance. Det giver et resultat, men det vil være <b>mindre nøjagtigt</b> end normalt, og bør kontrolleres i felten.": "You can choose to recalculate with a looser tolerance. This gives a result, but it will be <b>less accurate</b> than normal and should be checked in the field.",
	"Nulstil indstillinger": "Reset settings",
	"Nulstil alle Digitalisering-indstillinger til standardværdier?": "Reset all Digitization settings to their default values?",
	"Nulstil": "Reset",
	"Indstillinger": "Settings",
	"Interaktion": "Interaction",
	"Generelt": "General",
	"Midtpunkt": "Midpoint",
	"Midterlinje / Connector": "Midline / Connector",
	"Vinkelret / parallel": "Perpendicular / parallel",
	"Vektorredigering": "Vector editing",
	"Topologi": "Topology",
	"Snap": "Snap",
	"Slår automatisk snap til/fra overalt i PointView: når musen er tæt på et eksisterende punkt, springer det nye punkt til det - i Registrering, Måling og tegningerne i sidepanelet. Slået fra placeres punkter præcis hvor du klikker i punktskyen. Skjulte registreringer snappes der aldrig til. De eksplicitte handlinger 'Snap til punktsky' og 'Snap til andet punkt' virker altid, uanset denne indstilling.": "Switches automatic snap on/off everywhere in PointView: when the mouse is close to an existing point, the new point jumps to it - in Registration, Measurement and the drawings in the side panel. When switched off, points are placed exactly where you click in the point cloud. The explicit actions Snap to point cloud and Snap to another point always work.",
	"Snap-afstand": "Snap distance",
	"Hvor tæt (i skærm-pixels) musen skal være på et eksisterende punkt for at snappe til det - i Registrering og Måling. Målt på skærmen, så følelsen er den samme uanset zoom. Gyldige værdier er 3–50 px. Tegningerne og Mål i sidepanelet arbejder i meter og bruger en fast snap-afstand; de følger kun til/fra-kontakten.": "How close (in screen pixels) the mouse must be to an existing point to snap to it - in Registration and Measurement. Measured on the screen, so the feel is the same regardless of zoom. Valid values are 3–50 px. The drawings and Measure in the side panel use the same value.",
	"Overfladedetektion": "Surface detection",
	"Hjælper med at placere målinger og registreringer på den forreste overflade i punktskyen og reducerer risikoen for at ramme punkter bag den overflade, du arbejder på. En lille cirkel viser den fundne overflade og dens retning og er dæmpet, når overfladen ikke kan bestemmes sikkert.": "Helps place measurements and registrations on the front surface of the point cloud and reduces the risk of hitting points behind the surface you are working on. A small circle shows the found surface and its direction and is dimmed when the cursor is not on a surface.",
	"Standardafstand": "Default distance",
	"Forudfylder afstandsdialogen med denne værdi, hver gang Vinkelret punkt/linje eller Parallelforskydning aktiveres. Dialogen vises stadig, og værdien kan altid ændres eller slettes for den enkelte registrering. Lad stå på 0 for ingen standardværdi.": "Pre-fills the distance dialog with this value every time Perpendicular point/line or Parallel offset is activated. The dialog is still shown, and the value can always be changed or cleared for the individual registration. Leave at 0 for no default distance.",
	"Vis hjælpelinjer": "Show helper lines",
	"Viser hjælpelinjer (fx den vinkelrette forbindelseslinje til basislinjen) under registrering. Påvirker kun visningen, ikke det registrerede resultat.": "Shows helper lines (e.g. the perpendicular connection line to the baseline) during registration. Only affects the display, not the registered result.",
	"Vis afstand": "Show distance",
	"Viser den aktuelle afstand til basislinjen i preview under registrering. Påvirker kun visningen.": "Shows the current distance to the baseline in the preview during registration. Only affects the display.",
	"Vis projektionspunkt": "Show projection point",
	"Viser det beregnede projektionspunkt (foden på basislinjen) under registrering. Påvirker kun visningen.": "Shows the calculated projection point (the foot on the baseline) during registration. Only affects the display.",
	"Vis basislinje under registrering": "Show baseline during registration",
	"Holder den digitaliserede basislinje synlig, mens det vinkelrette/parallelle resultat placeres. Basislinjen indgår ikke selv i det registrerede resultat.": "Keeps the digitized baseline visible while the perpendicular/parallel result is placed. The baseline itself is not part of the registered result.",
	"Maksimal pilhøjde": "Maximum sagitta",
	"Angiver hvor langt et punkt højst må flyttes eller fjernes fra den oprindelige vektorgeometri ved automatisk udretning og forenkling.": "Specifies how far a point may at most be moved or removed from the original vector geometry during automatic straightening and simplification.",
	"Vinkeltolerance": "Angle tolerance",
	"Angiver hvor langt en eksisterende vinkel må afvige fra 90° eller 180°, før den medtages i ortogonaliseringen.": "Specifies how far an existing angle may deviate from 90° or 180° before it is included in the orthogonalization.",
	"Plan-tolerance (XY)": "Plane tolerance (XY)",
	"Hvor tæt to geometrier skal være i plan (XY), inkl. bånd ud over en linjes eget endepunkt, for at tælle som en reel skæring/forbindelse ved Forlæng, Trim, Sæt punkt ved skæring, Saml linjer og registrering af delte forbindelsespunkter.": "How close two geometries must be in the plane (XY), including the band beyond a line's own endpoint, to count as a real intersection/connection for Extend, Trim, Set point at intersection, Join lines and registration of shared connection points.",
	"Zoom til": "Zoom to",
	"Topologi-tjek": "Topology check",
	"Ingen problemer fundet.": "No problems found.",
	"Mindre gaps mellem endpoints": "Small gaps between endpoints",
	"Nul-længde segmenter / dublerede vertices": "Zero-length segments / duplicate vertices",
	"Utilsigtede selvskæringer": "Unintended self-intersections",
	"Ugyldige polygoner": "Invalid polygons",
	"Delte forbindelsespunkter (informativ - ikke et problem)": "Shared connection points (informational - not a problem)",
	"Operationen blev ikke gennemført.": "The operation was not completed.",
	"Beregnet maksimal afvigelse:": "Calculated maximum deviation:",
	"Tilladt maksimal pilhøjde:": "Allowed maximum sagitta:",
	"Øg \"Maksimal pilhøjde\" under Indstillinger → Vektorredigering, hvis resultatet er acceptabelt.": "Increase \"Maximum sagitta\" under Settings → Vector editing if the result is acceptable.",
	"Fast vinkel": "Fixed angle",
	"Tilpasser de to valgte segmenter til den angivne vinkel med mindst mulig geometrisk ændring.": "Adjusts the two selected segments to the specified angle with the smallest possible geometric change.",
	"Vinkel [°]": "Angle [°]",
	"Afstand [cm]": "Distance [cm]",
	"fx -15 eller 15": "e.g. -15 or 15",
	"Kote [m]": "Elevation [m]",
	"Operationen blev ikke gennemført, fordi resultatet ikke længere ville være en gyldig polygon (selvskæring eller for lille areal).": "The operation was not completed because the result would no longer be a valid polygon (self-intersection or too small an area).",
	"Ingen punktsky er indlæst.": "No point cloud is loaded.",
	"Tværprofilrapport": "Cross-section report",
	"Genererer rapport…": "Generating report…",
	"Beregner Z for de øvrige punkter i intervallet ud fra referencepunktets kote og den angivne hældning. X/Y ændres ikke.": "Calculates Z for the other points in the interval from the elevation of the reference point and the specified slope. X/Y are not changed.",
	"Sæt fald/hældning": "Set fall/slope",
	"Hældning": "Slope",
	"fx -5 eller 2.5": "e.g. -5 or 2.5",
	"‰ (promille)": "‰ (per mille)",
	"% (procent)": "% (percent)",
	"Referencepunkt (fastholdt kote)": "Reference point (fixed elevation)",
	"Startpunkt": "Start point",
	"Slutpunkt": "End point",
	"Flyt musen i punktskyen for at forhåndsvise ny position. Venstreklik bekræfter. ESC annullerer.": "Move the mouse in the point cloud to preview the new position. Left-click confirms. ESC cancels.",
	"Flyt punkt i Z": "Move point in Z",
	"Flyt linje i Z": "Move line in Z",
	"Flyt segment i Z": "Move segment in Z",
	"Flyt del i Z": "Move part in Z",
	"Flytter det valgte punkt lodret. Positivt tal flytter op, negativt tal flytter ned.": "Moves the selected point vertically. A positive number moves up, a negative number moves down.",
	"Sæt kote": "Set elevation",
	"Sætter det valgte punkts absolutte kote (Z). X/Y ændres ikke.": "Sets the absolute elevation (Z) of the selected point. X/Y are not changed.",
	"Snap til nærmeste punktsky punkt": "Snap to nearest point cloud point",
	"Der blev ikke fundet noget punktskypunkt ved dette punkt.": "No point cloud point was found at this point.",
	"Snap til andet punkt": "Snap to another point",
	"Vælg punktet der skal snappes til. ESC annullerer.": "Select the point to snap to. ESC cancels.",
	"Fast vinkel kræver et vertex med et segment på hver side (ikke vektorens første eller sidste punkt).": "Fixed angle requires a vertex with a segment on each side (not the first or last point of the vector).",
	"Parallel med reference": "Parallel to reference",
	"Vinkelret på reference": "Perpendicular to reference",
	"Klik på et referencesegment på en digitaliseret vektor. ESC annullerer.": "Click a reference segment on a digitized vector. ESC cancels.",
	"Klik på en referencelinje. ESC annullerer.": "Click a reference line. ESC cancels.",
	"Klik på et andet endepunkt. ESC annullerer.": "Click another endpoint. ESC cancels.",
	"Del linje": "Split line",
	"Deling her ville give en del med færre end 2 punkter.": "Splitting here would give a part with fewer than 2 points.",
	"Saml med anden linje": "Join with another line",
	"De valgte linjer mødes ikke inden for tolerancen (nærmeste afstand: {0}).": "The selected lines do not meet within the tolerance (nearest distance: {0}).",
	"Fortsæt linje": "Continue line",
	"Venstreklik for at tilføje punkter. Højreklik for at afslutte.": "Left-click to add points. Right-click to finish.",
	"Forlæng til reference": "Extend to reference",
	"Linjen når ikke referencegeometrien i den retning, den peger.": "The line does not reach the reference geometry in the direction it points.",
	"Forlæng endesegment": "Extend end segment",
	"Flytter endepunktet langs endesegmentets egen retning. Positivt tal forlænger linjen, negativt tal afkorter den.": "Moves the endpoint along the end segment's own direction. A positive number extends the line, a negative number shortens it.",
	"Afkortningen ville flytte endepunktet til eller forbi dets eget naboendepunkt.": "The shortening would move the endpoint to or past its own neighboring endpoint.",
	"Endesegmentet har ingen udstrækning at forlænge i retningen af.": "The end segment has no extent to extend in the direction of.",
	"Trim til reference": "Trim to reference",
	"Operationen blev ikke gennemført, fordi resultatet ville have færre end 2 punkter.": "The operation was not completed because the result would have fewer than 2 points.",
	"Linjen krydser ikke referencegeometrien.": "The line does not cross the reference geometry.",
	"Trim mod linje": "Trim against line",
	"Linjerne krydser ikke hinanden set fra oven (i planen). Kontrollér at linjerne faktisk skærer hinanden.": "The lines do not cross each other seen from above (in the plane). Check that the lines actually intersect.",
	"Forbind til andet endpoint": "Connect to another endpoint",
	"Sæt punkt ved skæring": "Set point at intersection",
	"Linjerne krydser ikke hinanden set fra oven (i planen).": "The lines do not cross each other seen from above (in the plane).",
	"Omtegn del": "Redraw section",
	"Tegn det nye forløb for den valgte del. Venstreklik tilføjer punkt, højreklik afslutter. ESC annullerer.": "Draw the new route for the selected section. Left-click adds a point, right-click finishes. ESC cancels.",
	"Bue fra pilhøjde": "Arc from sagitta",
	"Intervallets to endepunkter er sammenfaldende - der kan ikke beregnes en bue.": "The two endpoints of the interval coincide - an arc cannot be calculated.",
	"Rediger bue": "Edit arc",
	"Positiv pilhøjde buer til den ene side, negativ til den anden. Ændringen vises direkte i 3D, mens du skriver.": "A positive sagitta curves to one side, a negative to the other. The change is shown directly in 3D while you type.",
	"Pilhøjde [cm]": "Sagitta [cm]",
	"Godkend": "Accept",
	"Pilhøjde 0 - ret linje (ingen bue)": "Sagitta 0 - straight line (no arc)",
	"Vælg sammenhængende del": "Select connected section",
	"Venstreklik for at vælge startposition på vektoren.": "Left-click to select the start position on the vector.",
	"Venstreklik for at vælge slutposition på vektoren. ESC annullerer.": "Left-click to select the end position on the vector. ESC cancels.",
	"Snap til dette punkt": "Snap to this point",
	"{0} punkt blev ikke flyttet, fordi objektet er bundet til en integration (geometrien er låst).": "{0} point was not moved because the object is bound to an integration (the geometry is locked).",
	"{0} punkter blev ikke flyttet, fordi objektet er bundet til en integration (geometrien er låst).": "{0} points were not moved because the object is bound to an integration (the geometry is locked).",
	"Ryd valgte": "Clear selected",
	"Slet valgte punkter ({0})": "Delete selected points ({0})",
	"Slet valgte objekter ({0})": "Delete selected objects ({0})",
	"{0} punkter valgt": "{0} points selected",
	"Rør - godstykkelse": "Pipe - wall thickness",
	"Angiv rørets godstykkelse i mm, hvis den er kendt. Feltet kan efterlades tomt.": "Enter the wall thickness of the pipe in mm, if known. The field can be left empty.",
	"Godstykkelse [mm] - valgfri": "Wall thickness [mm] - optional",
	"meter (antaget - ingen IfcUnitAssignment fundet)": "meters (assumed - no IfcUnitAssignment found)",
	"METRE": "METRE",
	"Længdeenhed: {0} (× {1} = meter)": "Length unit: {0} (× {1} = meters)",
	"Bemærk: {0} IfcSite fundet i filen - bruger den første.": "Note: {0} IfcSite found in the file - using the first one.",
	"  Translation: ({0}, {1}, {2}) m - allerede indeholdt i elementernes egen geometri, ingen ekstra forskydning påført.": "  Translation: ({0}, {1}, {2}) m - already contained in the elements' own geometry, no extra offset applied.",
	"Georeferering: IfcSite.RefLatitude/RefLongitude/RefElevation (kilde: IfcSite - IfcLocalPlacement gav ingen brugbar global position)": "Georeferencing: IfcSite.RefLatitude/RefLongitude/RefElevation (source: IfcSite - IfcLocalPlacement gave no usable global position)",
	"  Lat/lon: {0}°, {1}° -> projiceret til EPSG:25832: ({2}, {3}, {4}) m": "  Lat/lon: {0}°, {1}° -> projected to EPSG:25832: ({2}, {3}, {4}) m",
	"  Ingen rotationsoplysning tilgængelig fra RefLatitude/RefLongitude - antager 0° rotation.": "  No rotation information available from RefLatitude/RefLongitude - assuming 0° rotation.",
	"Ingen georeferering fundet i filen - antager {0} / {1} og bruger filens egne koordinater uændret.": "No georeferencing found in the file - assuming {0} / {1} and using the file's own coordinates unchanged.",
	"default (ingen georeferering fundet i filen)": "default (no georeferencing found in the file)",
	"Ingen .obj-fil valgt.": "No .obj file selected.",
	"Egenskaber": "Properties",
	"Systemfelter": "System fields",
	"Bygning": "Building",
	"Etage": "Storey",
	"Ukendt": "Unknown",
	"WFS-svaret for \"{0}\" er {1} MB - for stort til at indlæse. Sandsynligvis filtrerer WFS'en ikke korrekt på bbox (kontrollér BBOX/CRS-parametrene mod serverens egne krav), eller også dækker laget reelt et meget større område end forventet. Prøv en mindre bufferzone, eller undersøg laget direkte hos WFS-udbyderen.": "The WFS response for \"{0}\" is {1} MB - too large to load. The WFS probably does not filter correctly on bbox (check the BBOX/CRS parameters against the server's own requirements), or the layer actually covers a much larger area than expected.",
	"WFS'en svarede ikke inden for {0} sekunder - prøv en mindre bufferzone, eller kontrollér WFS-URL'en/serverens status": "The WFS did not respond within {0} seconds - try a smaller buffer zone, or check the WFS URL/the server status",
	"WFS-kald fejlede (HTTP {0}) for \"{1}\"": "WFS request failed (HTTP {0}) for \"{1}\"",
	"WFS-svar for \"{0}\" kunne ikke tolkes som XML": "The WFS response for \"{0}\" could not be parsed as XML",
	"WFS-fejl for \"{0}\": {1}": "WFS error for \"{0}\": {1}",
	"ukendt fejl": "unknown error",
	"GetCapabilities-svaret kunne ikke tolkes som XML": "The GetCapabilities response could not be parsed as XML",
	"Serveren svarede ikke inden for {0} sekunder - prøv en mindre bufferzone, eller kontrollér adressen/serverens status": "The server did not respond within {0} seconds - try a smaller buffer zone, or check the address/the server status",
	"{0}: svaret er {1} MB - for stort til at indlæse. Prøv en mindre bufferzone.": "{0}: the response is {1} MB - too large to load. Try a smaller buffer zone.",
	"{0}: svaret er ikke JSON - er adressen en OGC API - Features-tjeneste? (kontrollér adressen)": "{0}: the response is not JSON - is the address an OGC API - Features service? (check the address)",
	"Hentning af lag": "Fetching layers",
	"Hentning af landingsside": "Fetching landing page",
	"Svaret er ikke en OGC API - Features-lagliste (mangler 'collections') - kontrollér adressen.": "The response is not an OGC API - Features layer list (missing 'collections') - check the address.",
	"Hentning af \"{0}\"": "Fetching \"{0}\"",
	"{0}: laget kan ikke leveres i punktskyens koordinatsystem, og en bbox i lon/lat mangler til at hente det i standardsystemet": "{0}: the layer cannot be delivered in the coordinate system of the point cloud, and a bbox in lon/lat is missing to fetch it in the default system",
	"{0}: svaret er ikke en GeoJSON FeatureCollection": "{0}: the response is not a GeoJSON FeatureCollection",
	"{0}: serveren svarede i et andet koordinatsystem ({1}) end det, der blev bedt om ({2})": "{0}: the server responded in a different coordinate system ({1}) than the one requested ({2})",
	"Kunne ikke hente punktdata fra serveren: {0}": "Could not fetch point data from the server: {0}",
	"Dekodning af node {0} fejlede": "Decoding of node {0} failed",
	"Skærmbilledet kunne ikke oprettes": "The screenshot could not be created",
	"Tidsudløb ved indlæsning af punktsky-node \"{0}\".": "Timeout while loading point cloud node \"{0}\".",
	"Annulleret": "Cancelled",
	"Baggrundskort (terræn)": "Base map (terrain)",
	"IFC-model": "IFC model",
	"GIS": "GIS",
	"Terræn (baggrundskort)": "Terrain (base map)",
	"Registrering er ikke tilgængelig - kun profiltegningen vises.": "Registration is not available - only the profile drawing is shown.",
	"Hjørne": "Corner",
	"Kant": "Edge",
	"Negativ volumen: {0} {1}³ (+/- 15%)\nPositiv volumen: {2} {3}³ (+/- 15%)\nAreal: {4} {5}²": "Negative volume: {0} {1}³ (+/- 15%)\nPositive volume: {2} {3}³ (+/- 15%)\nArea: {4} {5}²",
	"Støj": "Noise",
	"Terræn": "Terrain",
	"Anlægsgrav": "Excavation pit",
	"Ledninger": "Pipes/Cables",
	"{0} – vis/skjul ({1})": "{0} – show/hide ({1})",
	"Annullér": "Cancel",
	"Slet profil": "Delete profile",
	"Slet": "Delete",
	"Profil": "Profile",
	"Kopiér": "Copy",
	"Omdøb": "Rename",
	"Formatindstillinger": "Format settings",
	"Kolonner": "Columns",
	"Tilføj kolonne": "Add column",
	"Kolonnenavn": "Column name",
	"Datakilde": "Data source",
	"Preview": "Preview",
	"Outputmodel": "Output model",
	"Én række pr. objekt": "One row per object",
	"Én række pr. vertex": "One row per vertex",
	"Separator": "Separator",
	"Komma (,)": "Comma (,)",
	"Semikolon (;)": "Semicolon (;)",
	"Tabulator": "Tab",
	"Andet…": "Other…",
	"Egen separator": "Custom separator",
	"Decimaltegn": "Decimal separator",
	"Encoding": "Encoding",
	"UTF-8": "UTF-8",
	"UTF-8 BOM": "UTF-8 BOM",
	"Koordinatdecimaler": "Coordinate decimals",
	"Standard (højst 4)": "Standard (at most 4)",
	"Header (kolonnenavne på første linje)": "Header (column names on the first line)",
	"decimalkomma": "decimal comma",
	"decimalpunktum": "decimal point",
	"decimaltegn \"{0}\"": "decimal separator \"{0}\"",
	"én række pr. vertex": "one row per vertex",
	"én række pr. objekt": "one row per object",
	"Format:": "Format:",
	"{0} · separator {1} · {2} · {3}{4}": "{0} · separator {1} · {2} · {3}{4}",
	" · uden header": " · no header",
	"<select aria-label=\"Datakilde\"></select>": "<select aria-label=\"Data source\"></select>",
	"Fortløbende nummer (1, 2, 3 …)": "Sequential number (1, 2, 3 …)",
	"Alle attributter (dynamisk)": "All attributes (dynamic)",
	"Fast værdi": "Fixed value",
	"Træk for at flytte (eller Alt + pil op/ned)": "Drag to move (or Alt + arrow up/down)",
	"Flyt kolonne {0}": "Move column {0}",
	"Fjern kolonne": "Remove column",
	"Ingen kolonner endnu. Brug <b>Tilføj kolonne</b> for at komme i gang.": "No columns yet. Use <b>Add column</b> to get started.",
	"Eksempeldata - der er ingen registreringer endnu.": "Sample data - there are no registrations yet.",
	"Første 8 rækker af dine registreringer.": "The first 8 rows of your registrations.",
	"Intet at vise endnu.": "Nothing to show yet.",
	"Færdig": "Done",
	"Ny kolonne": "New column",
	"Ny profil {0}": "New profile {0}",
	"Navn på ny profil": "Name of new profile",
	"Profilen indeholder alle kolonner - slet dem, der ikke skal med.": "The profile contains all columns - delete the ones that should not be included.",
	"Omdøb profil": "Rename profile",
	"Navn på kopi": "Name of copy",
	"Den sidste profil kan ikke slettes.": "The last profile cannot be deleted.",
	"Slet profilen \"{0}\"? Dette kan ikke fortrydes.": "Delete the profile \"{0}\"? This cannot be undone.",
	"Nord (grid-nord for punktskyens koordinatsystem)": "North (grid north for the coordinate system of the point cloud)",
	"Vis beregningsflade": "Show calculation surface",
	"Vis referenceplan": "Show reference plane",
	"Vis trekantnet": "Show triangle mesh",
	"⚠ Beregnet med løsere tolerance - resultatet er mindre nøjagtigt end normalt.": "⚠ Calculated with a looser tolerance - the result is less accurate than normal.",
	"Overfladen vises ikke her: den gemmes ikke, og beregnes først igen, når polygonen redigeres.": "The surface is not shown here: it is not saved, and is calculated again only when the polygon is edited.",
	"⚠ Geometrien er ændret siden beregningen - resultatet er forældet.": "⚠ The geometry has changed since the calculation - the result is outdated.",
	"▸ Teknisk QA": "▸ Technical QA",
	"Værdi kopieret til udklipsholder:": "Value copied to clipboard:",
	"Værktøj: {0} &nbsp;|&nbsp; Geometri: {1}": "Tool: {0} &nbsp;|&nbsp; Geometry: {1}",
	"Vis/skjul resultat-label": "Show/hide result label",
	"Vis/skjul labels": "Show/hide labels",
	"Registreringer": "Registrations",
	"▾ Eksport": "▾ Export",
	"<b>Digitalisering</b>": "<b>Digitization</b>",
	"Vis/skjul objekt": "Show/hide object",
	"Omfang": "Scope",
	"Alle objekter": "All objects",
	"Valgte objekter": "Selected objects",
	"Format": "Format",
	"Redigér profiler...": "Edit profiles...",
	"Ingen objekter at eksportere": "No objects to export",
	"Genererer eksport…": "Generating export…",
	"Eksport mislykkedes: {0}": "Export failed: {0}",
	"Krydsning: objekter": "Crossing: objects",
	"Kote (m)": "Elevation (m)",
	"{0} (kopi)": "{0} (copy)",
	"Areal (m²)": "Area (m²)",
	"Polygonen indeholder ugyldige (NaN/uendelige) koordinater.": "The polygon contains invalid (NaN/infinite) coordinates.",
	"Vandret: {0}": "Horizontal: {0}",
	"Hurtig klassifikationsvisning (1-4)": "Quick classification display (1-4)",
	"Kopiér koordinater under musen (C)": "Copy coordinates under the mouse (C)",
	"Flyt i Z…": "Move in Z…",
	"Rediger {0}…": "Edit {0}…",
	"Graverapport {0}": "Excavation report {0}",
	"2D-profil": "2D profile",
	"Godstykkelse: {0} mm": "Wall thickness: {0} mm",
	"Ydre topkote: {0} m": "Outer top elevation: {0} m",
	"Indre topkote: {0} m": "Inner top elevation: {0} m",
	"Centerkote: {0} m": "Center elevation: {0} m",
	"Indre bundkote: {0} m": "Inner bottom elevation: {0} m",
	"Ydre bundkote: {0} m": "Outer bottom elevation: {0} m",
	"Vinkel: {0}°": "Angle: {0}°",
	"Areal: {0}": "Area: {0}",
	"Omkreds: {0}": "Perimeter: {0}",
	"Azimut (nettets nord): {0}°": "Azimuth (grid north): {0}°",
	"Centrum: {0}, {1}, {2}": "Center: {0}, {1}, {2}",
	"{0} segmenter": "{0} segments",
	"Antal segmenter: {0}": "Number of segments: {0}",
	"Beskrivelse: {0}": "Description: {0}",
	"Midtpunkt (preview)\nX: {0}\nY: {1}\nZ: {2}": "Midpoint (preview)\nX: {0}\nY: {1}\nZ: {2}",
	"Midtpunkt {0}": "Midpoint {0}",
	"Afstand: {0} m": "Distance: {0} m",
	"\nAfstand: {0} m": "\nDistance: {0} m",
	"{0}  (ESC afbryder)": "{0}  (ESC aborts)",
	"{0}… {1} m, {2} sektioner": "{0}… {1} m, {2} sections",
	"Beregningen fejlede ({0}).": "The calculation failed ({0}).",
	"{0} {1} – Centerlinje": "{0} {1} – Centerline",
	"{0} {1} – Toplinje": "{0} {1} – Top line",
	"foran fladen": "in front of the face",
	"bagved fladen": "behind the face",
	"3-akset laser": "3-axis laser",
	"Bredde: {0}": "Width: {0}",
	"Beregningen mislykkedes: {0}": "The calculation failed: {0}",
	"Radius: {0} · {1} segmenter": "Radius: {0} · {1} segments",
	"{0} objekter valgt": "{0} objects selected",
	"Areal: {0} m²": "Area: {0} m²",
	"Udgravning: {0}": "Excavation: {0}",
	"Volumen (coarse):": "Volume (coarse):",
	"Volumen (normal):": "Volume (normal):",
	"Volumen (fine):": "Volume (fine):",
	"Positiv konvergens (normal→fine):": "Positive convergence (normal→fine):",
	"Negativ konvergens (normal→fine):": "Negative convergence (normal→fine):",
	"QA mesh-antal:": "QA mesh count:",
	"Maks. |lokal position|:": "Max. |local position|:",
	"Randpunkter (original → densificeret):": "Boundary points (original → densified):",
	"Referenceplan maks. residual:": "Reference plane max. residual:",
	" Teknisk QA": " Technical QA",
	"Lukker huller i overfladen ...": "Closing holes in the surface ...",
	"Beregningen fejlede: ": "The calculation failed: ",
	"Starter beregning ...": "Starting calculation ...",
	"Midtpunkt: {0} / {1}": "Midpoint: {0} / {1}",
	"Graverapport.pdf": "Excavation_report.pdf",
	"Graverapport_{0}.pdf": "Excavation_report_{0}.pdf",
	"Jordpunkter (klasse 2)": "Ground points (class 2)",
	"Graverapport — {0} (fortsat)": "Excavation report — {0} (continued)",
	"meter (antaget - intet LENGTHUNIT fundet)": "meters (assumed - no LENGTHUNIT found)",
	"meter (antaget - ukendt enhedstype)": "meters (assumed - unknown unit type)",
	"Georeferering: IfcMapConversion (kilde: IfcMapConversion/IfcProjectedCRS)": "Georeferencing: IfcMapConversion (source: IfcMapConversion/IfcProjectedCRS)",
	"Georeferering: IfcSite.ObjectPlacement (kilde: IfcSite, hele IfcLocalPlacement-hierarkiet)": "Georeferencing: IfcSite.ObjectPlacement (source: IfcSite, the entire IfcLocalPlacement hierarchy)",
	"ukendt geometri": "unknown geometry",
	"GetCapabilities fejlede (HTTP {0})": "GetCapabilities failed (HTTP {0})",
	"{0} fejlede (HTTP {1}){2}": "{0} failed (HTTP {1}){2}",
	"Inspektionsrapport.pdf": "Inspection_report.pdf",
	"Inspektionsrapport_{0}.pdf": "Inspection_report_{0}.pdf",
	"PointView · Inspektionsrapport": "PointView · Inspection report",
	"{0} forfaldne": "{0} overdue",
	" (vinkelret)": " (perpendicular)",
	"Kote {0}": "Elevation {0}",
	"Snit {0}": "Section {0}",
	"komma": "comma",
	"semikolon": "semicolon",
	"tabulator": "tab",
	" (kun vertex-tilstand)": " (vertex mode only)",
	"▸ Eksport": "▸ Export",
	"{0} (kommer snart)": "{0} (coming soon)",
	"Beregningen blev afbrudt, fordi analysegrundlaget blev større end forventet ({0} rå punkter).": "The calculation was aborted because the analysis basis became larger than expected ({0} raw points).",
	"Beregningen blev afbrudt, fordi antallet af punkter inden for polygonen blev større end forventet ({0}).": "The calculation was aborted because the number of points inside the polygon became larger than expected ({0}).",
	"Beregningen blev afbrudt, fordi antallet af reducerede observationer blev større end forventet ({0}).": "The calculation was aborted because the number of reduced observations became larger than expected ({0}).",
	"Beregningen blev afbrudt, fordi randens opdeling blev større end forventet ({0} randpunkter).": "The calculation was aborted because the subdivision of the boundary became larger than expected ({0} boundary points).",
	"Beregningen blev afbrudt, fordi antallet af trekanter blev større end forventet ({0}).": "The calculation was aborted because the number of triangles became larger than expected ({0}).",
	"Vindue: vertices": "Window: vertices",
	"Ukendt eller ikke-understøttet DANVA-namespace: \"{0}\". Understøttet i denne version: DANVAND 1.1.0/2.1.1, DANDAS 2.5.2/2.6.0/3.1.1 (ikke DANVAND 2.0.0).": "Unknown or unsupported DANVA namespace: \"{0}\". Supported in this version: DANVAND 1.1.0/2.1.1, DANDAS 2.5.2/2.6.0/3.1.1 (not DANVAND 2.0.0).",
	"(intet)": "(none)",
	"Ukendt DANVA-dokumenttype: rodelement \"{0}\".": "Unknown DANVA document type: root element \"{0}\".",
	"Komponenter understøttes kun for DANVAND i denne version.": "Components are only supported for DANVAND in this version.",
	"TV-inspektion understøttes kun for DANDAS.": "CCTV inspection is only supported for DANDAS.",
	"DANVA – Knuder (vand)": "DANVA – Nodes (water)",
	"DANVA – Knuder (afløb)": "DANVA – Nodes (drainage)",
	"DANVA – Ledninger (vand)": "DANVA – Pipes (water)",
	"DANVA – Ledninger (afløb)": "DANVA – Pipes (drainage)",
	"DANVA – Komponenter (vand)": "DANVA – Components (water)",
	"DANVA – TV-inspektion (afløb)": "DANVA – CCTV inspection (drainage)",
	"Knude": "Node",
	"Ledning": "Pipe",
	"Komponent": "Component",
	"TV-inspektion": "CCTV inspection",
	"Beholder": "Vessel",
	"Boring": "Bore",
	"Samling": "Joint",
	"Kombikomponent": "Combined component",
	"Målerenhed": "Metering unit",
	"Forbrugssted": "Consumption point",
	"Pumpe": "Pump",
	"Reservoir": "Reservoir",
	"Tapsted": "Tapping point",
	"Ventil": "Valve",
	"Flytter alle linjens punkter lodret med en valgt afstand eller rørdimension.": "Moves all points of the line vertically by a chosen distance or pipe dimension.",
	"Flytter segmentets to punkter lodret med en valgt afstand eller rørdimension.": "Moves the two points of the segment vertically by a chosen distance or pipe dimension.",
	"Flytter den valgte dels punkter lodret med en valgt afstand eller rørdimension.": "Moves the points of the selected part vertically by a chosen distance or pipe dimension.",
	"Positivt tal flytter op, negativt tal flytter ned.": "A positive number moves up, a negative number moves down.",
	"Standard": "Standard",
	"Vand": "Water",
	"Spildevand": "Sewer",
	"Fjernvarme": "District heating",
	"Afstand · cm": "Distance · cm",
	"Dimension · mm": "Dimension · mm",
	"Dimension · mm (handelsmål)": "Dimension · mm (trade size)",
	"Dimension · DN": "Dimension · DN",
	"Godstykkelse (mm)": "Wall thickness (mm)",
	"Træk godstykkelsen fra forskydningen": "Subtract the wall thickness from the offset",
	"Læg godstykkelsen til forskydningen": "Add the wall thickness to the offset",
	"Z-forskydning (cm)": "Z offset (cm)",
	"Flyt ned": "Move down",
	"Flyt op": "Move up",
	"Godstykkelsen skal være mindre end dimensionen.": "The wall thickness must be smaller than the dimension.",
	"DN{0} · Kappe Ø{1} mm · Top til centerlinje": "DN{0} · Casing Ø{1} mm · Top to centerline",
	"Der er ikke data nok til at udføre beregningen: {0} % af området inden for polygonen har ingen punkter.": "There is not enough data to carry out the calculation: {0} % of the area inside the polygon has no points.",
	"Uden klasser: {0}": "Without classes: {0}",
	"Uden klasser:": "Without classes:",
	"klasse {0}": "class {0}",
};
